/** @file Select tool registration: title and activation chord Q (viewport context). */
import type { ToolDef } from '../../stores/types';

/** Picks bones and slots, marquee-selects joints, drags socket and handle points (E1.7). */
export const tool: ToolDef = { id: 'select', title: 'tools.select.title', bindings: [{ id: 'tool.select', keys: 'KeyQ', context: 'viewport' }] };
